import {MONTHS} from "../constants/index.jsx";

export const detectMobile = () => {
    return {
        isMobile: window.innerWidth <= 1024,
        isMobileLandscape: (window.innerHeight < window.innerWidth && window.innerHeight < 641)
    }
};

export const setDataInLocalStorage = (key, value) => {
    localStorage.setItem(key, value)
}

export const handleStyles = (name, defaultIndex) => {
    const itemIndex = localStorage.getItem(name)
    if (!itemIndex) {
        setDataInLocalStorage(name, defaultIndex)
        return defaultIndex
    }
    return itemIndex
}
export const updateCardClasses = (refArray, index, removeClass, addClasses) => {
    const cardRef = refArray.current[index];
    if (cardRef) {
        cardRef.classList.remove(...removeClass);
        cardRef.classList.add(...addClasses);
    }
};

export const formatTimestamp = function (timestamp, format, lang = "en") {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const monthNumber = String(date.getMonth() + 1).padStart(2, '0');
    const monthName = MONTHS?.[lang][date.toLocaleDateString('en-US', {month: 'short'})];
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    if (format === "full-date") {
        return `${year}-${monthNumber}-${day} ${hours}:${minutes}:${seconds}`
    }
    if (format === "time") {
        return `${hours}:${minutes}`
    }
    if (format === "day-month-time") {
        return `${day}/${monthNumber} ${hours}:${minutes}`
    }
    if (format === "monthName-day-time") {
        return `${monthName} ${day} | ${hours}:${minutes}`
    }
    if (format === "time-monthName-day") {
        return `${hours}:${minutes} ${monthName} ${day}`
    }
}

export const calcAmount = (tournamentInfo = {}, playerPoints, currency) => {
    if (Object.values(tournamentInfo)?.length) {
        const mainPrice = tournamentInfo?.roundPrice?.[currency];
        let lastRound = playerPoints / 10;
        if (lastRound > tournamentInfo?.reBuyLimit) {
            return tournamentInfo?.betAmountGrowUpScheme?.[tournamentInfo?.reBuyLimit]?.[currency];
        }
        if (lastRound <= 0) return mainPrice;
        if (lastRound >= tournamentInfo?.round) return tournamentInfo?.betAmountGrowUpScheme?.[tournamentInfo?.round]?.[currency];
        let playersBetSum = 0;
        for (let i = 0; i <= lastRound; i++) {
            playersBetSum += tournamentInfo?.betAmountGrowUpScheme?.[i]?.[currency];
        }
        return mainPrice - playersBetSum;

    }
}

export const handleTournamentBuyIn = (tournamentInfo, currency, points) => {
    if (!tournamentInfo?.hasReBuy || tournamentInfo?.round === 0) {
        return tournamentInfo?.buyIn?.[currency]
    }
    if (tournamentInfo?.round > 0) {
        if (tournamentInfo.round > tournamentInfo.reBuyLimit) {
            return tournamentInfo?.roundPrice?.[currency]
        }
        return calcAmount(tournamentInfo, points, currency)
    }
}

export const handleTournamentReBuy = (tournamentInfo, currency, points) => {
    if (tournamentInfo?.round === 0) {
        return tournamentInfo?.roundPrice?.[currency]
    } else {
        if (tournamentInfo.round > tournamentInfo.reBuyLimit) {
            return tournamentInfo?.roundPrice?.[currency]
        }
        return calcAmount(tournamentInfo, points, currency)
    }
}
export const groupByRoundId = (data) => {
    const grouped = {};

    for (const item of data) {
        const roundId = item?.round?.id;

        if (roundId == null) continue; // Skip if round.id is missing or null

        if (!grouped[roundId]) {
            grouped[roundId] = [];
        }

        grouped[roundId].push(item);
    }

    return Object.values(grouped);
}

export const omitBy = (obj, predicate) => {
    return Object.fromEntries(
        Object.entries(obj).filter(
            ([key, value]) => !predicate(value, key)
        )
    );
};

export const getNewReferenceByCondition = (array, conditionFn) => {
    const foundItem = array.find(conditionFn);
    return foundItem ? { ...foundItem } : null;
}
